export function pluralize(count: number, singular: string, plural?: string, suffix = 's'): string {
  if (count <= 1) return singular
  return plural ? plural : `${singular}${suffix}`
}
